import { Component, OnInit , Input, Output, EventEmitter} from '@angular/core';
import { IqSizeData } from '../../modals/orderentry/orderentry.component';

@Component({
  selector: 'dropDownInput',
  template: require('./dropdownInput.component.html'),
  styles: [require('./dropdownInput.component.scss')]
})
export class dropdownInputComponent implements OnInit {

  @Input() public list:IqSizeData[] = [];
  @Input() public inputValue: number = 0;
  @Input() public newLayout: boolean = false;
  
  @Output('update')
  change: EventEmitter<number> = new EventEmitter<number>();

  increment() {
    this.change.emit(this.currentValue);
  }

  private _dropdownInputMode: boolean = false;
  public get dropdownInputMode (): boolean {
    return this._dropdownInputMode;
  }
  public set dropdownInputMode ( value: boolean ) {
    this._dropdownInputMode = value;
  }


  private _currentValue: number = 0;
  public get currentValue (): number {
    return this._currentValue;
  }
  public set currentValue ( v: number ) {

    if(v==-1)
    {
      this.dropdownInputMode = true;
      this._currentValue = this.currentValue;
    }
    else
    {
       this._currentValue = v;
    }
   
  }

  constructor() {
   
  }

  ngOnInit() { 
    console.log([this.inputValue])
    console.log(this.list)

    let find = this.list.filter((v)=>v.value==this.inputValue);

    if(find.length==0)
    {
      this.dropdownInputMode = true;
    }

    this.currentValue=this.inputValue;
  }
}
